export * from './abstract.input';



// WEBPACK FOOTER //
// ./src/app/shared/components/inputs/abstract/index.ts